import { render } from "./post-smtp-documentation.vue?vue&type=template&id=37ef17f0&scoped=true"
import script from "./post-smtp-documentation.vue?vue&type=script&lang=js"
export * from "./post-smtp-documentation.vue?vue&type=script&lang=js"

import "./post-smtp-documentation.vue?vue&type=style&index=0&id=37ef17f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ef17f0"],['__file',"src/components/post-smtp-documentation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37ef17f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37ef17f0', __exports__)) {
    api.reload('37ef17f0', __exports__)
  }
  
  module.hot.accept("./post-smtp-documentation.vue?vue&type=template&id=37ef17f0&scoped=true", () => {
    api.rerender('37ef17f0', render)
  })

}


export default __exports__